<template>
    <v-col cols="12" md="6" align="center" class="pl-5">
        <v-col cols="12" align="start" class="ml-4 mt-4 color-text text-h5">
            {{ $t('home.store') }}
        </v-col>
        <v-card
            class="pa-4 bg-store"
            elevation="12"
            :height="this.$vuetify.breakpoint.xs||this.$vuetify.breakpoint.sm||this.$vuetify.breakpoint.md?250:230"
            to="/user/store"
        >
            <v-row align="center">
                <v-col cols="7" xl="9" class="white--text text-left text-h4 font-weight-regular">
                    {{ $t('home.store_desc') }}
                </v-col>
            </v-row>
            <v-overlay absolute value="true" opacity="0" class="overlay">
                <v-img src="/img/user/store-bg.svg" max-height="200" width="270"></v-img>
            </v-overlay>
        </v-card>
    </v-col>
</template>

<script>
export default {
    
}
</script>
<style scoped>
.v-card {
    border-radius: 20px;
}
.bg-store {
    background: rgb(207,73,154);
    background: linear-gradient(90deg, rgba(207,73,154,1) 0%, rgba(134,116,184,1) 50%, rgba(47,165,218,1) 100%);
}
.overlay {
    justify-content: flex-end;
    margin-right: -60px;
    padding-top: 30px;
}
</style>